import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TestsComponent } from '../tests/tests.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {path: 'tests', component: TestsComponent, data: {breadcrumb: 'Test Maintenance'}}
        ])
    ],
    declarations: []
})
export class TestsModule { }